import { FC, useCallback } from 'react';

import { REGIONS } from '@packages/constants';
import { Region } from '@packages/types';

import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { ROUTES } from '@routes/types';
import { closeModalSelector, useModalStore } from '@store';
import { clearSessionStorage, testProps } from '@utils';

import { Flag } from '../flag';

export const RegionGrid: FC = () => {
  const regions = Object.values(REGIONS);
  const closeModal = useModalStore(closeModalSelector);
  const onSelect = useCallback(
    (data: Region) => {
      clearSessionStorage();
      window.location.href = `/${ROUTES.QUOTE}/${data.country.toLowerCase()}`;

      closeModal();
    },
    [closeModal],
  );
  return (
    <div>
      <Text variant="subHeading-14/m" className="mb-4">
        {i18n.t('global.countryOfResidency.modal.subtitle')}
      </Text>
      <ul role="list" className="grid grid-cols-2 gap-4">
        {regions.map(({ code, name }) => (
          <li
            key={code}
            className="bg-cabo-50 border-cabo-200 col-span-1 flex flex-col rounded-md border text-center shadow hover:border-fuji-800 hover:border-opacity-30">
            <button
              {...testProps(`select-country-button-${name}`)}
              className="flex flex-1 flex-col items-center p-5 rounded-md"
              onClick={() => onSelect({ country: code })}>
              <Text variant="subTitle-20/sb" className="mb-5">
                {name}
              </Text>
              <Flag country={code} className="w-24" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
